import { render, staticRenderFns } from "./the-page-header.vue?vue&type=template&id=1b2182ba&scoped=true"
import script from "./the-page-header.vue?vue&type=script&lang=js"
export * from "./the-page-header.vue?vue&type=script&lang=js"
import style0 from "./the-page-header.vue?vue&type=style&index=0&id=1b2182ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2182ba",
  null
  
)

export default component.exports